import { render, staticRenderFns } from "./OfferBlock.vue?vue&type=template&id=23621167&scoped=true"
import script from "./OfferBlock.vue?vue&type=script&lang=ts"
export * from "./OfferBlock.vue?vue&type=script&lang=ts"
import style0 from "./OfferBlock.vue?vue&type=style&index=0&id=23621167&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23621167",
  null
  
)

export default component.exports